import * as React from 'react';
import styleable from "react-styleable";
import Downshift, { GetInputPropsOptions, GetItemPropsOptions, GetMenuPropsOptions } from "downshift";
import matchSorter from 'match-sorter';

import * as styles from '../../../css/components/mainlayout/PortalDropdown.css';

// Inspiration: https://codesandbox.io/s/github/kentcdodds/downshift-examples

function ArrowIcon({ isOpen }) {
    return (
        <svg
            viewBox="0 0 20 20"
            preserveAspectRatio="none"
            width={16}
            fill="transparent"
            stroke="#979797"
            strokeWidth="1.1px"
            transform={isOpen ? 'rotate(180)' : null}
        >
            <path d="M1,6 L10,15 L19,6" />
        </svg>
    )
}

function XIcon() {
    return (
        <svg
            viewBox="0 0 20 20"
            preserveAspectRatio="none"
            width={12}
            fill="transparent"
            stroke="#979797"
            strokeWidth="1.1px"
        >
            <path d="M1,1 L19,19" />
            <path d="M19,1 L1,19" />
        </svg>
    )
}

const itemToString = i => (i ? i.title : '');

const Input = styleable(styles)(class A extends React.Component<any, any, any>{
    render() {
        let { isOpen, ...other } = this.props;
        return <input {...other} className={this.props.css.input + " " + (this.props.isOpen ? this.props.css.inputOpen : "")} />
    }
});

const ControllerButton = styleable(styles)(class A extends React.Component<any, any, any>{
    render() {
        return <button {...this.props} className={this.props.css.controllerButton} />;
    }
});

const BaseMenu = styleable(styles)(class A extends React.Component<any, any, any>{
    render() {
        let { isOpen, ...other } = this.props;
        return <ul {...other} className={this.props.css.baseMenu + " " + (this.props.isOpen ? "" : this.props.css.baseMenuNotOpen)}>{this.props.children}</ul>;
    }
});

const Item = styleable(styles)(class A extends React.Component<any, any, any>{
    render() {
        let { isActive, isSelected, ...other } = this.props;
        return <li {...other} className={this.props.css.item + (this.props.isSelected ? " " + this.props.css.itemSelected : "") + (this.props.isActive ? " " + this.props.css.itemActive : "")} >{this.props.children}</li>;
    }
});

function getItems(items: [], filter) {
    return filter
        ? matchSorter(items, filter, {
            keys: ['title'],
        })
        : items
}

// TODO: also use this for list boxes for example

/**
 * # Props
 * - **immediatelyClearSelection** Set to true to immediately clear selection upon change. Important: this will initiate an additional onSelectionChange(null) callback
 * - **showToggleButton** Set to true to always show the toggleButten. This is false by default.
 */
class PortalDropdown extends React.Component<any, any, any> {

    render() {

        let selectedItemProp = {};
        if (this.props.selectedId !== undefined) {
            selectedItemProp = { selectedItem: null }
            for (let item of this.props.items) {
                if (item.id === this.props.selectedId)
                    selectedItemProp = { selectedItem: item }
            }
        }

        return (
            <div className={this.props.css.outerDiv}>
                <Downshift
                    onChange={(selection, {clearSelection}) => {
                        if (this.props.onSelectionChange){
                            this.props.onSelectionChange(selection);

                        }
                        if (this.props.immediatelyClearSelection === true) {
                            clearSelection();
                        }
                    }}
                    {...selectedItemProp}
                    itemToString={itemToString}
                >
                    {({
                        getLabelProps,
                        getInputProps,
                        getToggleButtonProps,
                        getMenuProps,
                        getItemProps,
                        isOpen,
                        clearSelection,
                        selectedItem,
                        inputValue,
                        highlightedIndex,
                    }) => {
                        return (
                            <div className={this.props.css.containerDiv}>
                                {/*<label {...getLabelProps()}>Enter a fruit</label>*/}
                                <i {...getLabelProps()} className={this.props.css.label}>{this.props.placeholder}</i>
                                <div className={this.props.css.inputContainerDiv}>
                                    <Input
                                        css={this.props.css}
                                        {...getInputProps({
                                            isOpen,
                                            placeholder: this.props.placeholder,
                                        } as any)}
                                    />
                                    {(selectedItem && !this.props.showToggleButton) ? (
                                        <ControllerButton
                                            {...getToggleButtonProps()}
                                            onClick={(e) => {
                                                clearSelection();
                                                if(getToggleButtonProps()?.onClick) getToggleButtonProps().onClick(e)
                                            }}
                                            aria-label="clear selection"
                                        >
                                            <XIcon />
                                        </ControllerButton>
                                    ) : (
                                            <ControllerButton {...getToggleButtonProps()}>
                                                <ArrowIcon isOpen={isOpen} />
                                            </ControllerButton>
                                        )}
                                </div>
                                <div className={this.props.css.menuContainerDiv}>
                                    <BaseMenu {...getMenuProps({ isOpen } as any)}
                                        css={this.props.css}>
                                        {isOpen
                                            ? getItems(this.props.items, this.props.showToggleButton? false: inputValue).map((item, index) => (
                                                <Item
                                                    css={this.props.css}
                                                    key={item.id}
                                                    {...getItemProps({
                                                        item,
                                                        index,
                                                        isActive: highlightedIndex === index,
                                                        isSelected: selectedItem === item,
                                                    } as GetItemPropsOptions<any>)}
                                                >
                                                    {item?.preview ?? itemToString(item)}
                                                </Item>
                                            ))
                                            : null}
                                    </BaseMenu>
                                </div>
                            </div>
                        );
                    }
                    }
                </Downshift>
            </div>
        );
    }
}
export default styleable(styles)(PortalDropdown);